import ApiClient from '@package/services/src/ApiClient'
import Result, { EmptyResult } from '@package/services/src/Result'

import { BullseyeBucksService } from './services'
import {
  LoyaltyPoints,
  RedeemLoyaltyPoints,
} from './types'

class BullseyeBucksApiService implements BullseyeBucksService {
  public constructor(private apiClient: ApiClient) { }

  public async getLoyaltyPoints(): Promise<Result<LoyaltyPoints>> {
    try {
      const res = await this.apiClient.get('/shoppingCart/loyalty')
      const json: LoyaltyPoints = await res.json()

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      return new Result(json)
    } catch (error) {
      console.error('Unable to get Loyalty points')
      return new Result({earnedPoints: 0, redemptionAmounts: []})
    }
  }

  public async redeemLoyaltyPoints(
    request: RedeemLoyaltyPoints
  ): Promise<EmptyResult> {
    await this.apiClient.post('/shoppingCart/loyalty/redeem', {
      body: request,
    })

    return new EmptyResult()
  }
}

export default BullseyeBucksApiService;
